import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {Subject, Subscription} from "rxjs";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import { NgModel, FormsModule } from "@angular/forms";
import { MatFormField, MatLabel, MatError } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { RequireTldDirective } from '../require-tld.directive';

@Component({
    selector: 'app-weave-input',
    templateUrl: './weave-input.component.html',
    styleUrls: ['./weave-input.component.scss'],
    imports: [MatFormField, MatLabel, MatInput, FormsModule, RequireTldDirective, MatError]
})
export class WeaveInputComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() data: string;
  @Input() type: string = "text"; // 'text' | 'email' | 'password' | 'number' | 'tel' | 'url'
  @Input() step: number; // for type='number'
  @Input() min: number; // for type='number'
  @Input() max: number; // for type='number'
  @Input() disabledFlag: boolean;
  @Input() appearance: 'outline' | 'fill' | 'standard' = "outline"; // 'outline' | 'fill' | 'standard'
  @Input() label: string = "";
  @Input() description: string = "";
  @Input() placeholder: string = "";
  @Input() maxlength: number = 524288;
  @Input() required: boolean = false;
  @Input() longTitle: boolean = false;
  @Input() emailValidator: boolean = false;
  @Input() showError: boolean = false;
  @Input() hideRequiredMarker: boolean = false;
  @Output() focusOut: EventEmitter<string> = new EventEmitter<string>();
  @Output() keyUp: EventEmitter<string> = new EventEmitter<string>();
  @Output() keyUpChar: EventEmitter<string> = new EventEmitter<string>();
  @Output() keyDown: EventEmitter<string> = new EventEmitter<string>();
  @Output() keyDownEvent: EventEmitter<KeyboardEvent> = new EventEmitter<KeyboardEvent>();
  @Output() keyUpDebounced: EventEmitter<string> = new EventEmitter<string>();
  @Output() inputIsValid: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() keyUpEnter: EventEmitter<void> = new EventEmitter<void>();
  @Output() paste: EventEmitter<ClipboardEvent> = new EventEmitter<ClipboardEvent>();

  tempValue: any;
  id: string = "";
  message: string = "";

  private keyUpDebouncedSubject  = new Subject<string>();
  private keyUpDebouncedSubscription: Subscription;
  @ViewChild('ctrl') field: NgModel;
  @ViewChild('inputElement') inputElement: ElementRef<HTMLInputElement>;

  constructor() {}

  ngOnInit() {
    this.id = "weave-input" + Math.floor(Math.random() * 1000);

    this.keyUpDebouncedSubscription = this.keyUpDebouncedSubject
      .pipe(
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((results: string) => (this.keyUpDebounced.emit(results)));

    this.message = this.label;
    if( this.message.length > 30 || this.message.length == 0 ) {
      this.message = "This field";
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if(this.field) {
        this.inputIsValid.emit(this.field.valid);
      }
    }, 50);
  }

  ngOnDestroy() {
    this.keyUpDebouncedSubscription.unsubscribe();
  }

  onKeyUpEnter() {
    this.keyUpEnter.emit();
  }

  onFocusOut() {
    this.showError = false;
    this.focusOut.emit(this.data);
  }
  onKeyUp(event: Event) {
    this.keyUp.emit(this.data);
    if(this.field){
      this.inputIsValid.emit(this.field.valid);
    }
    this.keyUpDebouncedSubject.next(this.data);
    this.keyUpChar.emit((event as KeyboardEvent).key);
  }

  onKeyDown(event: Event) {
    this.keyDown.emit((event as KeyboardEvent).key);
    this.keyDownEvent.emit(event as KeyboardEvent);
  }

  startEdit() {
    this.tempValue = this.data;
  }

  onPaste(event: ClipboardEvent) {
    this.paste.emit(event);
  }

  public focusInput() {
    this.inputElement.nativeElement.focus();
  }

  public selectInput() {
    this.inputElement.nativeElement.select();
  }

  undo() {
    this.data = this.tempValue;
  }
}
